// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"91b5d5c4","598":"93a8247d","787":"83ef177f"}[chunkId] + ".chunk.js";
};